/**
 * ヘッダー商品検索のライブ候補
 * - CB260924: 候補は検索ページと同じ索引・同じ照合（assets/search-index.js）で出す。
 *   検索対象＝商品名・品番名カナ・ブランド・マテリアル・スペック。正規化（全半角・かな・大小文字・空白）もそちら。
 *   旧実装は /products.json を商品名・handle・SKUで照合していた＝検索ページ（自前索引）と候補が食い違うため揃えた。
 * - 候補クリックで商品ページへ。Enter/アイコン送信は /search（検索ページ）。
 */
(function () {
  var inputs = document.querySelectorAll('.site-nav__search-input');
  if (!inputs.length || !window.AsplundSearchIndex) return;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  var style = document.createElement('style');
  style.textContent =
    '.site-nav__search-form{position:relative}' +
    '.hsearch-results{position:absolute;top:calc(100% + 6px);right:0;width:320px;max-width:80vw;background:#fff;border:1px solid #e5e0d8;border-radius:var(--radius-box);box-shadow:0 12px 32px rgba(0,0,0,.12);max-height:60vh;overflow:auto;z-index:1000}' +
    '.hsearch-results[hidden]{display:none}' +
    '.hsearch-hint{padding:14px 16px;font-size:13px;color:#8a8375}' +
    '.hsearch-item{display:flex;align-items:center;gap:10px;padding:10px 12px;text-decoration:none;color:#2e2e2c;border-bottom:1px solid #f0ece5}' +
    '.hsearch-item:last-child{border-bottom:none}' +
    '.hsearch-item:hover{background:#f7f5f1}' +
    '.hsearch-thumb{width:40px;height:40px;flex:0 0 auto;object-fit:cover;background:#f0ece5;border-radius:2px;display:block}' +
    '.hsearch-info{display:flex;flex-direction:column;min-width:0}' +
    '.hsearch-title{font-size:13px;line-height:1.4;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.hsearch-vendor{font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:#8a8375}';
  document.head.appendChild(style);

  Array.prototype.forEach.call(inputs, function (input) {
    var form = input.closest('.site-nav__search-form') || input.parentElement;
    var dd = document.createElement('div');
    dd.className = 'hsearch-results';
    dd.hidden = true;
    form.appendChild(dd);
    var timer = null;

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (timer) clearTimeout(timer);
      if (q.length < 2) { dd.hidden = true; dd.innerHTML = ''; return; }
      timer = setTimeout(function () { run(q, dd); }, 250);
    });
    input.addEventListener('focus', function () {
      // 入力を始める前に索引を読み始める＝初回検索（候補・検索ページとも）の待ちを縮める
      window.AsplundSearchIndex.load().catch(function () {});
      if (dd.innerHTML) dd.hidden = false;
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) dd.hidden = true; });
  });

  function run(q, dd) {
    dd.hidden = false;
    dd.innerHTML = '<div class="hsearch-hint">検索中...</div>';
    window.AsplundSearchIndex.load().then(function (items) {
      var m = window.AsplundSearchIndex.search(q, items).slice(0, 8);
      if (!m.length) { dd.innerHTML = '<div class="hsearch-hint">該当する商品がありません</div>'; return; }
      dd.innerHTML = m.map(function (p) {
        var src = p.i || '';
        if (src && src.indexOf('//') === 0) src = 'https:' + src;
        return '<a class="hsearch-item" href="/products/' + esc(p.h) + '">' +
          (src ? '<img src="' + esc(src) + '" alt="" class="hsearch-thumb">' : '<span class="hsearch-thumb"></span>') +
          '<span class="hsearch-info"><span class="hsearch-title">' + esc(p.t) + '</span>' +
          (p.b ? '<span class="hsearch-vendor">' + esc(p.b) + '</span>' : '') +
          '</span></a>';
      }).join('');
    }).catch(function () { dd.innerHTML = '<div class="hsearch-hint">検索に失敗しました</div>'; });
  }
})();
